// The website chat's script (client/packs/web-chat.js) is not in gwmc.js:
// this injects it on the first tap of the chat button and hands over.
// The layout writes its digested URL as window.__WEB_CHAT_JS only while the
// website chat is on (CHAT_ENTRY=webchat and a widget token).

export const webChatScript = (win = globalThis.window) => {
  const src = win && win.__WEB_CHAT_JS
  return typeof src === 'string' ? src.trim() : ''
}

// Once per page; a failed load lets the next tap try again.
let loading = null
export const loadWebChat = ({ src = webChatScript(), win = globalThis.window, doc = globalThis.document, timeoutMs = 15000 } = {}) => {
  if (win.gwmcWebChat) return Promise.resolve(win.gwmcWebChat)
  if (loading) return loading
  if (!src) return Promise.reject(new Error('no website chat script'))

  loading = new Promise((resolve, reject) => {
    const fail = err => { clearTimeout(timer); loading = null; reject(err) }
    const timer = setTimeout(() => fail(new Error('website chat script timed out')), timeoutMs)
    const script = doc.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => (win.gwmcWebChat ? (clearTimeout(timer), resolve(win.gwmcWebChat)) : fail(new Error('website chat script empty')))
    script.onerror = () => fail(new Error('website chat script did not load'))
    doc.head.appendChild(script)
  })
  return loading
}

export const resetWebChatLoader = () => { loading = null }
